import { PunchupRecipientInfoForm } from './components/PunchupRecipientInfoForm';
import { SendTicketsFormProps } from './types';

/**
 * PunchupSendTicketsForm — non-seated single-recipient form body.
 *
 * Renders the recipient info card (name, email, ticket quantities).
 * The show title section and mode toggle live at the page level and are
 * intentionally excluded here — this component owns the form body only.
 */
export const PunchupSendTicketsForm = ({ event, poolBudget }: SendTicketsFormProps) => {
	if (!event) return null;
	return <PunchupRecipientInfoForm ticketTypes={event.ticketTypes} poolBudget={poolBudget} />;
};
